import React from 'react';
import { get, isEmpty, isEqual, find } from 'lodash';
import { withRouter } from 'react-router-dom';
import searchQuery from 'query-string';

// React view component to render
import { memberOrderDetailSummary as MemberOrderDetailSummaryView } from 'ui/views/widgets/memberOrderDetailSummary';
import { MemberOrderDetailSummaryService } from 'services/memberOrderDetailSummary';
import { SERVICE_RESPONSE_STATUS, ORIGIN, GLOBAL_LABELS, SIZES, CANCELLED_ORDER_STATUS, ERROR_RESPONSE_TEMPLATE } from 'constants/common';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import * as errorOverlay from 'utils/errorOverlay';
import {trackingDetailsOverlayView as TrackingDetailsOverlayView } from 'ui/views/widgets/trackingDetailsOverlay';

import { overlay } from 'modules/overlay';
import { OVERLAY_VIEWS } from 'constants/templates';
import * as successOverlay from 'utils/successOverlay';
import { getLabel } from 'utils/getLabel';
import * as confirmOverlay from 'utils/confirmOverlay';
import { messageBus as MessageBus } from 'core/modules/message-bus';
import * as MESSAGE_BUS_EVENTS from 'constants/message-bus-events';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberOrderDetailSummary } from 'ui/containers/MemberOrderDetailSummary';
 *
 * // render
 * <MemberOrderDetailSummary propName='propValue'/>
 */
class _MemberOrderDetailSummary extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.handleActionClick = this.handleActionClick.bind( this );
        this.fetchLiveOrderStatus = this.fetchLiveOrderStatus.bind( this );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
            displayTrackingDialog: false,
            parcelShieldResponseData:{},
            isCheckingLiveStatus: false,
            liveStatusAsOf: null,
            liveStatusError: null,
        };

        // create service instance
        this.memberOrderDetailSummaryService = new MemberOrderDetailSummaryService();

        // start data fetch
        this.fetchComponentData();
         
    }

    initiateTrackingNumber( parcelshieldData ) {
        log.debug( 'MemberDetailsOrdersEntityWidget.initiateTrackingNumber()' );
            this.setState( {
                displayTrackingDialog: true,
                parcelShieldResponseData: parcelshieldData
                
            } )
    }

    async fetchComponentData() {
        log.debug( 'MemberOrderDetail.fetchComponentData()' );

        // cancel ongoing request
        this.memberOrderDetailSummaryService.cancel();

        // get status and service data
        const { status, data } = await this.memberOrderDetailSummaryService.fetchComponentData( {
            url: this.props.widget.url,
            data: {
                ...this.props.requestPayload
            }
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            }, () => {

            } );
        }
    }


    /**
     * initiate edit order
     */
    async initiateEditOrder( { url } ) {
        log.debug( 'MemberOrderDetail.initiateEditOrder()' );

        // cancel ongoing request
        this.memberOrderDetailSummaryService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        const memberId = get( this.props, 'requestPayload.context.memberId', null );
        const orderId = get( this.props, 'requestPayload.context.orderId', null );

        // fetch component data
        const { status } = await this.memberOrderDetailSummaryService.initiateEditOrder( {
            url: url,
            data: {
                context: {
                    memberId
                },
                data: {
                    orderId
                },
            },
        } );

        // hide page level preloader
        pageLevelPreloader.hide();

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
            }, () => {

                // redirect to edit order checkout page
                this.props.history.push( {
                    pathname: DASHBOARD_SUB_ROUTES.EDIT_ORDER,
                    search: searchQuery.stringify( {
                        orderId: orderId,
                        origin: ORIGIN.ORDER_DETAIL
                    } ),
                    state: { memberId: memberId }
                } );
            } );
            
        } else {
            errorOverlay.open(); // show error
        }

    }

    /**
     * initiate edit order
     */
    async initiateReorder( { url } ) {
        log.debug( 'MemberOrderDetail.initiateEditOrder()' );

        // cancel ongoing request
        this.memberOrderDetailSummaryService.cancel();

        const memberId = get( this.props, 'requestPayload.context.memberId', null );
        const orderId = get( this.props, 'requestPayload.context.orderId', null );

        // show page level preloader
        pageLevelPreloader.show();

        // fetch component data
        const { status } = await this.memberOrderDetailSummaryService.initiateReorder( {
            url: url,
            data: {
                context: {
                    memberId
                },
                data: {
                    orderId
                },
            },
        } );

        // hide page level preloader
        pageLevelPreloader.hide();

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
            }, () => {

                // redirect to re order checkout page
                this.props.history.push( {
                    pathname: DASHBOARD_SUB_ROUTES.RE_ORDER,
                    search: searchQuery.stringify( {
                        orderId,
                        origin: ORIGIN.ORDER_DETAIL
                    } ),
                    satte: { memberId: memberId }
                } );
            } );
        } else {
            errorOverlay.open(); // show error
        }
    }

    /**
     * fetch controlled drug reorder info
     */
     async fetchControlledDrugReOrderInfo( { url, payload } ) {
        log.debug( 'MemberOrderDetail.initiateEditOrder()' );

        const orderId = get( this.props, 'requestPayload.context.orderId', null );

        // cancel ongoing request
        this.memberOrderDetailSummaryService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        // fetch component data
        const { status, data } = await this.memberOrderDetailSummaryService.fetchControlledDrugReOrderInfo( {
            url: url,
            data: {
                context: {
                    memberId: get( payload, 'memberId' )
                },
                data: {
                    orderId
                }
            }
        } );

        // hide page level preloader
        pageLevelPreloader.hide();

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            
            overlay.open( {
                settings: {
                    modalType: OVERLAY_VIEWS.CONTROLLED_DRUG_REORDER,
                    showCloseButton: false,
                    ignoreOutsideClick: false,
                },
                config: {},
                data: {
                    ...data,

                    // payload: payload,
                    requestPayload: payload,
                    onCancelClick: () => {
                        overlay.close();
                    },
                },
            } );

        } else {
            errorOverlay.open(); // show error
        }
    }

     /**
     * @desc Display MSR Notes.
     */
    async initNotes( { url } ) {
        log.debug( 'MemberOrderDetailSummary.initNotes()' );

        // cancel ongoing request
        this.memberOrderDetailSummaryService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        // get status and service data
        const { status, data } = await this.memberOrderDetailSummaryService.initNotes( {
            url: url,
            data: this.props.requestPayload
        } );

        // show page level preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

            overlay.open( {
                settings: {
                    modalType: OVERLAY_VIEWS.CSR_ORDER_NOTES,
                    showCloseButton: false,
                    ignoreOutsideClick: true,
                },
                config: {},
                data: {
                    data,
                    url: url,
                    orderId: get( this.props.requestPayload, 'context.orderId' ),
                    requestPayload: this.props.requestPayload,
                    onCancelClick: () => {
                        overlay.close();
                    },
                },
            } );
        }  else {
            errorOverlay.open(); // show error
        }
    }
    
    /**
     * @desc: cancel order
     */
    async initiateCancelOrder( { url, confirmation } ) {
        log.debug( 'MemberOrderDetailSummary.initiateCancelOrder()' );

        const memberId = get( this.props, 'requestPayload.context.memberId', null );
        const orderId = get( this.props, 'requestPayload.context.orderId', null );
        
        // cancel ongoing request
        this.memberOrderDetailSummaryService.cancel();

        const shouldProceed = await confirmOverlay.open( {
			message: getLabel( confirmation ),
			iconName: 'cancel'
        } );
        
        if( shouldProceed ) {

            // show page level preloader
            pageLevelPreloader.show();

            // fetch component data
            const { status, resData } = await this.memberOrderDetailSummaryService.cancelOrder( {
                url: url,
                data: {
                    context: {
                        memberId: memberId,
                    },
                    data: {
                        orderId: orderId,
                        orderStatus: CANCELLED_ORDER_STATUS,
                    },
                },
            } );

            // hide page level preloader
            pageLevelPreloader.hide();

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                }, () => {

                    successOverlay.open( {
                        message: getLabel(  GLOBAL_LABELS.DISPLAY_TEXT_DONE_SUCCESSFULLY ),
                    } );
    
                    MessageBus.trigger( MESSAGE_BUS_EVENTS.ORDER_DETAIL_REFRESH );
                } );
               

            } else {

                // show server message in case template is `notification`
                const template = get( resData, 'template', ERROR_RESPONSE_TEMPLATE.DEFAULT );

                if ( isEqual( template, ERROR_RESPONSE_TEMPLATE.notification ) ) {

                    errorOverlay.open( {
                        message: resData.description,
                        size: SIZES.SMALL,
                        template: resData.template
                    } );

                } else {
                    errorOverlay.open();
                }
            }
        }
    }

    /**
     * @desc: cancel order with reason
     */
    async initiateCaptureReasonsCancelOrder( { action, payload, /*cancelConfirmation*/ } ) {
        log.debug( 'MemberOrderDetailSummary.initiateCaptureReasonsCancelOrder()' );


        const memberId = get( payload, 'memberId', null );

        const orderId = get( this.props, 'requestPayload.context.orderId', null );

        overlay.open( {
            settings: {
                modalType: OVERLAY_VIEWS.CAPTURE_REASON_CANCEL_ORDER,
                showCloseButton: false,
                ignoreOutsideClick: true,
            },
            config: {},
            data: {
                ...action,
                widgetConfig: this.state.componentData.cancelOrder,
                onSumbitClick: async ( value ) => {
                    
                    overlay.close();

                    // cancel ongoing request
                    this.memberOrderDetailSummaryService.cancel();

                    // show page level preloader
                    pageLevelPreloader.show();

                    // fetch component data
                    const { status, resData } = await this.memberOrderDetailSummaryService.cancelOrder( {
                        url: action.url,
                        data: {
                            context: {
                                memberId
                            },
                            data: {
                                orderId,
                                cancelReason: value,
                                orderStatus: CANCELLED_ORDER_STATUS
                            },
                        },
                    } );

                    // show page level preloader
                    pageLevelPreloader.hide();

                    // check if response status was success
                    if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

                        this.setState( {
                            isFetching: false,
                            networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                        } );

                        MessageBus.trigger( MESSAGE_BUS_EVENTS.ORDER_DETAIL_REFRESH );
                        
                    } else {

                        const template = get( resData, 'template', ERROR_RESPONSE_TEMPLATE.DEFAULT );

                        if ( isEqual( template, ERROR_RESPONSE_TEMPLATE.notification ) ) {

                            errorOverlay.open( {
                                message: resData.description,
                                size: SIZES.SMALL,
                                template: resData.template
                            } );

                        } else {
                            errorOverlay.open();
                }
                    }
                },
                onCancelClick: () => {
                    overlay.close();
                },
            },
        } );
    }

    /**
     * initiate Mark Resolved
     */
    async initiateMarkResolved( { action } ) {
        log.debug( 'MemberOrderDetail.initiateMarkResolved()' );

        const memberId = get( this.props, 'requestPayload.context.memberId', null );
        const orderId = get( this.props, 'requestPayload.context.orderId', null );

        overlay.open( {
            settings: {
                modalType: OVERLAY_VIEWS.MARK_RESOLVED,
                showCloseButton: false,
                ignoreOutsideClick: true,
            },
            config: {},
            data: {
                ...action,
                widgetConfig: this.state.componentData.markResolved,
                onSumbitClick: async ( value ) => {
                    
                    overlay.close();

                    // cancel ongoing request
                    this.memberOrderDetailSummaryService.cancel();

                    // show page level preloader
                    pageLevelPreloader.show();

                    // fetch component data
                    const { status, resData } = await this.memberOrderDetailSummaryService.initiateMarkResolved( {
                        url: action.url,
                        data: {
                            context: {
                                memberId
                            },
                            data: {
                                orderId,
                                description: value
                            },
                        },
                    } );

                    // show page level preloader
                    pageLevelPreloader.hide();

                    // check if response status was success
                    if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

                        this.setState( {
                            isFetching: true,
                            networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                        }, () => {
                            MessageBus.trigger( MESSAGE_BUS_EVENTS.ORDER_DETAIL_REFRESH );
                        } );
                        
                    } else {

                        if ( ! isEmpty( resData.description ) ) {

                                errorOverlay.open( {
                                    message: resData.description,
                                    size: SIZES.SMALL,
                                    template: resData.template
                                } );

                        } else {
                            errorOverlay.open();
                        }
                        
                        // errorOverlay.open(); // show error
                    }
                },
                onCancelClick: () => {
                    overlay.close();
                },
            },
        } );
    }

    /**
     * @desc Fetch live order status from ePost and update displayed status.
     */
    async fetchLiveOrderStatus() {
        log.debug( 'MemberOrderDetailSummary.fetchLiveOrderStatus()' );

        if ( !get( this.props.requestPayload, 'context.orderId' ) ) {
            this.setState( { liveStatusError: 'FETCH_FAILED' } );
            return;
        }

        this.setState( { isCheckingLiveStatus: true, liveStatusError: null } );

        const { status, data, httpStatus } = await this.memberOrderDetailSummaryService.fetchLiveOrderStatus( {
            data: { ...this.props.requestPayload },
        } );

        if ( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            const liveOrderState = get( data, 'orderDetails.state', {} );
            const liveOrderValues = isEmpty( liveOrderState )
                ? get( data, 'orderDetails', {} )
                : get( liveOrderState, 'values', {} );
            const asOf = get( data, 'asOf', null );
            this.setState( ( prevState ) => ( {
                isCheckingLiveStatus: false,
                liveStatusAsOf: asOf,
                liveStatusError: null,
                componentData: {
                    ...prevState.componentData,
                    orderData: {
                        ...get( prevState, 'componentData.orderData', {} ),
                        ...( get( liveOrderState, 'actionsVisibility' ) ? {
                            actionsVisibility: {
                                ...get( prevState, 'componentData.orderData.actionsVisibility', {} ),
                                ...get( liveOrderState, 'actionsVisibility', {} ),
                            },
                        } : {} ),
                        ...( get( liveOrderState, 'iconsVisibility' ) ? {
                            iconsVisibility: {
                                ...get( prevState, 'componentData.orderData.iconsVisibility', {} ),
                                ...get( liveOrderState, 'iconsVisibility', {} ),
                            },
                        } : {} ),
                        values: {
                            ...get( prevState, 'componentData.orderData.values', {} ),
                            ...liveOrderValues,
                        },
                    },
                },
            } ) );
        } else {
            const errorType = httpStatus === 404 ? 'STATUS_UNAVAILABLE' : 'FETCH_FAILED';
            this.setState( { isCheckingLiveStatus: false, liveStatusError: errorType } );
            console.error( 'fetchLiveOrderStatus failed' );
        }
    }

    handleActionClick( { type, value, item } ) {
        log.debug( 'MemberOrderDetail.handleActionClick()' );
        if( 'cell' === type && 'trackingNumber' === value.name ) {
            const parcelshieldData = this.state.componentData?.orderData?.values?.parcelShield;
            return parcelshieldData
                ? this.initiateTrackingNumber( parcelshieldData )
                : window.open(this.state.componentData?.orderData?.values?.redirectUrl);
        }
        // get member id and order id
        const memberId = get( this.props, 'requestPayload.context.memberId', null );
        const orderId = get( item, 'id', null );

        if( 'headerAction' === type && 'edit' === value.name ) {
            this.initiateEditOrder( { url: value.url } );
        }

        if( 'headerAction' === type && 'markResolved' === value.name ) {
            this.initiateMarkResolved( { action: value, item: item } );
        }

        if( 'headerAction' === type && 'reorder' === value.name ) {

            //this.initiateReorder( { url: value.url } );
            const canReorder = get( this.state.componentData, 'orderData.values.canReorder' );
            const urlMapObject = find( value.urlMap, { 'canReorder': canReorder } );
            log.debug( this.state );
            log.debug( canReorder ) ;

            if( canReorder ) {
                return this.initiateReorder( {
                    url: urlMapObject.url,
                    payload: {
                        memberId,
                        orderId,
                    },
                } );
            } else if ( !canReorder ) {
                return this.fetchControlledDrugReOrderInfo( {
                    url: urlMapObject.url,
                    payload: {
                        memberId,
                        orderId,
                    },
                } );
            }
        }

        if( 'headerAction' === type && 'notes' === value.name ) {
            this.initNotes( { url: value.url } );
        }

        if( 'headerAction' === type && 'cancelOrder' === value.name ) {

            if( get( this.state, 'componentData.orderData.values.captureCancelReasons', false ) ) {
                return this.initiateCaptureReasonsCancelOrder( {
                    action: value,
                    payload: {
                        memberId,
                        orderId,
                    },
                    confirmation: value.confirmation
                } );
            } else{

                //this.initiateCancelorder( { url: value.url } );
                this.initiateCancelOrder( {
                    url: value.url,
                    payload: {
                        memberId,
                        orderId,
                    },
                    confirmation: value.confirmation
                } );
            }
        }
}

     /*********************************************/

    /**
     * @desc When component unMounts, cleanup resources.
     */
    componentWillUnmount() {
        this.memberOrderDetailSummaryService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <>
                <MemberOrderDetailSummaryView
                    isFetching={ this.state.isFetching }
                    networkStatus={ this.state.networkStatus }
                    componentData={ get( this.state, 'componentData', {} ) }
                    onActionClick={ this.handleActionClick }
                    isCheckingLiveStatus={ this.state.isCheckingLiveStatus }
                    liveStatusAsOf={ this.state.liveStatusAsOf }
                    liveStatusError={ this.state.liveStatusError }
                    onCheckLiveStatus={ this.fetchLiveOrderStatus }
                /> 
                {
                    this.state.displayTrackingDialog && 
                        <TrackingDetailsOverlayView
                            handleTrackingDialogClose={() => this.setState({ displayTrackingDialog: false })}
                            data={this.state.parcelShieldResponseData}
                        />
                }
            </>
        );
    }
}

// set display name
_MemberOrderDetailSummary.displayName = 'MemberOrderDetailSummary';

// set default props
_MemberOrderDetailSummary.defaultProps = {};

// prop types
_MemberOrderDetailSummary.propTypes = {};

export const MemberOrderDetailSummary = withRouter( _MemberOrderDetailSummary );
